// Hook: GET /company/locations - lista lokacji firmy klienta

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { ILocation } from 'api/types/company';

export interface IResponse {
  items: ILocation[];
  total?: number;
}

const getCompanyLocations = (): Promise<IResponse> => axios.get('/company/locations');

export const useGetCompanyLocations = (options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['company', 'locations'], () => getCompanyLocations(), options);
